<template>
  <section class="releases">
    <h1 class="releases-section-title">Próximos Estrenos</h1>
    <div
      v-if="comingMovies"
      class="releases-slider">
      <div
        v-for="movie in comingMovies"
        :key="movie.id"
        class="release-slide">
        <div class="release-card">
          <figure class="image release-preview">
            <img
              :src="movie.preview.guid"
              :alt="movie['movie-name']"
              :title="movie['movie-name']"
              width="100w">
          </figure>

          <a class="button is-small is-outlined is-white release-btn-play-trailer">
            <span class="icon">
              <play-icon/>
            </span>
            <span>Reproducir Tráiler</span>
          </a>
          <div class="release-info">
            <div class="release-poster">
              <figure class="image">
                <img
                  :src="movie.poster.guid"
                  :alt="movie['movie-name']"
                  :title="movie['movie-name']"
                  width="100w">
              </figure>
            </div>
            <div class="release-info-text">
              <h3 class="release-title">
                <span class="text">{{ movie['movie-name'] }}</span>
                <span class="more"/>
              </h3>
              <div class="release-meta">
                <span class="year">{{ movie.year }}</span>
                <span class="maturity-rating">{{ movie.rating[0] }}</span>
                <span class="duration">{{ movie.runtime }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';

import PlayIcon from 'vue-material-design-icons/Play.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Releases',
  components: {
    PlayIcon,
  },
  computed: {
    ...mapGetters([
      'comingMovies',
    ]),
  },
  updated() {
    tns({
      container: '.releases-slider',
      items: 1,
      lazyload: true,
      controls: true,
      mouseDrag: true,
      swipeAngle: false,
      speed: 1000,
      useLocalStorage: false,
      slideBy: 'page',
      gutter: 10,
      responsive: {
        640: {
          items: 2,
        },
        960: {
          items: 3,
        },
        1200: {
          items: 4,
        },
      },
    });
  },
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables";
@import "~bulma/sass/utilities/functions";
@import "~bulma/sass/utilities/derived-variables";
@import "~bulma/sass/utilities/mixins";
@import "~@/sass/variables";
@import '~tiny-slider/src/tiny-slider';

.releases {
  padding-left: 4%;
  margin-bottom: 2rem;

  .releases-section-title {
    color: lighten($dark-cyan-gray, 30);
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    font-size: 1.25rem;

    @include from(1000px) {
      font-size: 1.5rem;
    }
  }

  .releases-slider {
    @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
      padding-bottom: 56.25%;

      @include from(640px) {
        padding-bottom: calc(56.25% / 2);
      }

      @include from(960px) {
        padding-bottom: calc(56.25% / 3);
      }

      @include from(1200px) {
        padding-bottom: calc(56.25% / 4);
      }

      &:hover {
        .release-slide {
          &:hover {
            & ~ .release-slide {
              transform: translateX(10%);
            }
          }
        }
        .release-slide {
          transform: translateX(-10%);
          .release-card {
            &:hover {
              transform: translate(0%, -10%);
              width: 120%;
              transition: 400ms;
              transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);

              .release-btn-play-trailer {
                opacity: 1;
              }
            }
          }
        }
      }
    }
  }

  .release-slide {
    @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
      transition: 400ms;
      transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
    }

    width: 100%;
    padding-right: 10px;
    display: inline-block;

    @include from(640px) {
      width: 50%;
    }

    @include from(960px) {
      width: 33%;
    }

    @include from(1200px) {
      width: 25%;
    }
  }

  .release-card {
    position: relative;
    display: flex;
    flex-direction: column;

    @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
      position: absolute;
      padding: 5px;
      width: 100%;
      transition: 400ms;
      transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
    }

    .release-preview {
      padding-bottom: 56.25%;
      position: relative;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
      }

      &:after {
        content: '';
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0,
        rgba(0, 0, 0, 0.35) 40%, rgba(0, 0, 0, 0.85) 100%);
        position: absolute;
        left: 0px;
        right: 0px;
        bottom: 0px;
        top: 0px;
      }
    }

    .release-btn-play-trailer {
      background-color: rgba(0,0,0, 0.2);
      font-weight: bold;
      position: absolute;
      right: 4%;
      top: 4%;

      @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
        opacity: 0;
        transition: 400ms;
        transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
      }

      @include from(440px) {
        font-size: 1rem;
      }

      @include from(640px) {
        font-size: 0.85rem;
      }

      @include from(800px) {
        font-size: 1rem;

        .icon {
          span {
            width: 90%;
            height: 90%;
          }
        }
      }

      @include from(960px) {
        font-size: 0.85rem;
      }
    }

    .release-info {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 70%;
      display: flex;
      align-items: flex-end;
      padding-bottom: 4%;

      .release-poster {
        flex-shrink: 0;
        flex-basis: 20%;
        margin: 0 4%;

        .image {
          padding-bottom: 150%;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
          }
        }
      }

      .release-info-text {
        padding-right: 4%;
        width: 100%;

        .release-title {
          font-weight: bold;
          color: #fff;

          @include from(700px) {
            font-size: 1rem;
          }

          &.long {
            height: calc(1.5 * 2em);
            overflow: hidden;
            position: relative;

            &:before {
              content: '';
              width: 5px;
              height: calc(1.5 * 2em);
              float: left;
            }

            .text {
              color: findColorInvert($dark-cyan-blue);
              float: right;
              width: 100%;
              margin-left: -5px;
            }

            .more {
              width: 33%;
              margin-left: -33%;
              float: right;
              padding-right: 5px;
              position: relative;
              left: 100%;
              top: -1.25rem;
              box-sizing: content-box;
              background: linear-gradient(to right, rgba(0, 0, 0, 0) 0,
              rgba(0, 0, 0, 0.85) 50%, rgba(0, 0, 0, 1) 100%);
              height: 1rem;
              display: flex;
              justify-content: flex-end;
              align-items: center;

              @include from(700px) {
                top: -1.5rem;
                height: 1.5rem;
              }

              &:after {
                content: '... \00a0';
                font-size: 1rem;
                margin-top: -0.5rem;
                color: findColorInvert($dark-cyan-blue);
                margin-right: 0.25rem;
              }
            }

            @supports (-webkit-line-clamp: 2) {
              .text {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
              }

              .more {
                display: none;
              }
            }
          }
        }

        .release-meta {
          display: flex;
          color: #fff;
          font-weight: bold;
          font-size: 0.75rem;
          align-items: center;
          margin-top: 0.5rem;

          @include from(960px) {
            margin-top: 0.75rem;
          }

          span {
            margin-right: 5px;
          }

          .maturity-rating {
            height: 2em;
            display: inline-flex;
            border-radius: 4px;
            align-items: center;
            justify-content: center;
            line-height: 1.5;
            padding-left: 0.75em;
            padding-right: 0.75em;
            white-space: nowrap;
            border: solid 1px rgba(255,255,255,.4);
          }
        }
      }
    }
  }

  .tns-ovh {
    @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
      overflow: unset;
    }
  }

  .tns-item {
    @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
      position: relative;
    }
  }

  .tns-nav {
    position: absolute;
    right: 4%;
    top: -2.25rem;

    button {
      appearance: none;
      border: 0;
      padding: 0;
      margin: 0;
      background: #4d4d4d;
      width: 12px;
      height: 2px;
      margin-left: 2px;

      &.tns-nav-active {
        background: #aaa;
      }
    }
  }

  .tns-inner {
    margin-right: 40px !important;
  }

  .tns-outer {
    position: relative;
    @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
      &:hover {
        .tns-controls {
          button {
            display: block;
          }
        }
      }
    }
  }

  .tns-controls {
    button {
      @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
        display: none;
      }
      appearance: none;
      border: 0;
      padding: 0;
      margin: 0;
      background: rgba(20,20,20, 0.5);
      width: 3rem;
      height: 3rem;
      margin-top: -1.5rem;
      right: 0;
      position: absolute;
      @media (-moz-touch-enabled: 1), (hover: none) and (pointer: coarse) {
        top: 50%;
      }
      @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
        transform: translateY(175%);
      }
      z-index: 1;
      font-size: 0;
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path fill-opacity="0.85" fill="%23fff" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;

      &:first-of-type {
        left: calc(-4% - 5px);
        right: auto;
        background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path fill-opacity="0.85" fill="%23fff" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg>');
      }
    }
  }
}

</style>

